import { client } from "@payezy/api-client/public/client";
import type { Problem } from "@payezy/api-client/public";
import { Kratos } from "@payezy/auth";

export const API_URL: string = import.meta.env.VITE_API_URL ?? "http://localhost:7080";
export const KRATOS_URL: string = import.meta.env.VITE_KRATOS_URL ?? "http://localhost:4433";
export const kratos = new Kratos(KRATOS_URL);

const VIEW_AS_KEY = "payezy.viewAs";

/** Staff "view-as" token (set from the back-office); scoped to this browser tab. */
export const viewAs = {
  get: () => sessionStorage.getItem(VIEW_AS_KEY),
  set: (t: string) => sessionStorage.setItem(VIEW_AS_KEY, t),
  clear: () => sessionStorage.removeItem(VIEW_AS_KEY),
};

client.setConfig({ baseUrl: API_URL, credentials: "include" });
client.interceptors.request.use((request) => {
  const t = viewAs.get();
  if (t) request.headers.set("Authorization", `Bearer ${t}`);
  return request;
});

export function isProblem(e: unknown): e is Problem {
  return typeof e === "object" && e !== null && "code" in e && "status" in e;
}

export function problemMessage(e: unknown): string {
  if (isProblem(e)) return e.detail ?? e.title;
  if (e instanceof Error) return e.message;
  return "Something went wrong";
}

export function loginUrl(extra: Record<string, string> = {}): string {
  const qs = new URLSearchParams({ return_to: window.location.href, ...extra });
  return `/auth/login?${qs}`;
}

let redirecting = false;

/** Global handling for auth-related problems; returns true if handled. */
export function handleAuthProblem(e: unknown): boolean {
  if (!isProblem(e) || redirecting) return false;
  switch (e.code) {
    case "unauthorized":
      if (viewAs.get()) {
        viewAs.clear();
      }
      redirecting = true;
      window.location.assign(loginUrl());
      return true;
    case "impersonation_ended":
      viewAs.clear();
      redirecting = true;
      window.location.assign("/view-as/ended");
      return true;
    case "email_not_verified":
      redirecting = true;
      window.location.assign("/auth/verification");
      return true;
    case "step_up_required":
      redirecting = true;
      window.location.assign(loginUrl({ aal: "aal2", refresh: "true" }));
      return true;
    default:
      return false;
  }
}
